import { Component, OnInit, ViewChild, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidationErrors, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//import { EventEmitter } from '@angular/core';
import { LogsData } from 'src/app/model/LogsData';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NgbdModalContent } from '../../alert-component';
import * as Parse from 'parse';
import { QuizData } from '../QuizData';
import { CookieService } from 'ngx-cookie-service';
import { UserData } from 'src/app/model/UserData';

@Component({
  selector: 'app-comorbidityquiz',
  templateUrl: './comorbidityquiz.component.html',
  styleUrls: ['./comorbidityquiz.component.css']
})
export class ComorbidityquizComponent implements OnInit {

  comorbidityquizForm : FormGroup;
  failedMessage : string;
  submitted = false;
  successMessage: string;

  preexisting_conditions = [];

  constructor(
    private router : Router,
    private _bkoffService: BackOffServiceService,
    private modalService: NgbModal,
    private formBuilder : FormBuilder,
    private cookie: CookieService,

  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }

  ngOnInit(): void {
    
    this.comorbidityquizForm  =  this.formBuilder.group({

      preexisting_conditions: new FormArray([], minSelectedCheckboxes(1)),
      health_status: ['', Validators.required]

    });

    this.preexisting_conditions = this.getPreexistingConditions();
    this.addPreexistingConditionsCheckboxes();

    this.router.events.subscribe((evt) => {
      window.scrollTo(0, 0)
    });

  }

  private addPreexistingConditionsCheckboxes() {
    this.preexisting_conditions.map((o, i) => {
      const control = new FormControl(); // if first item set to true, else false
      (this.comorbidityquizForm.controls.preexisting_conditions as FormArray).push(control);
    });
  }

  get fmBuilder() { return this.comorbidityquizForm.controls; }

  reset(){
    this.comorbidityquizForm.reset({PersonalData: new QuizData()});
  }


  getFormControl(name:any) {
    return this.comorbidityquizForm.get(name);
  }

  
  getPreexistingConditions(){
    return [
      { value: 1, id: 'highBloodPressure', name: 'Hypertension/High Blood Pressure' },
      { value: 2, id: 'diabetes', name: 'Diabetes' },
      { value: 3, id: 'heartDisease', name: 'Heart disease or conditions' },
      { value: 4, id: 'cholesterol', name: 'High blood cholesterol' },
      { value: 5, id: 'cancer', name: 'Cancer' },
      { value: 6, id: 'depression', name: 'Depression or other mental illness' },
      { value: 7, id: 'asthma', name: 'COPD or asthma' },
      { value: 8, id: 'arthritis', name: 'Arthritis' },
      { value: 9, id: 'physicalDisability', name: 'Physical Disability or mobility issues' },
      { value: 10, id: 'multipleSclerosis', name: 'Multiple sclerosis or other nerve disorders' },
      { value: 11, id: 'none', name: 'None of the above' },
    ]
  }
  

  getFormValidationErrors() {
    var missingInput = false;
    Object.keys(this.comorbidityquizForm.controls).forEach(key => {
    const controlErrors: ValidationErrors = this.comorbidityquizForm.get(key).errors;
    if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            if (keyError === "required"){
              missingInput = true;
            }
          });
        }
      });
      return missingInput;
    }
  

   btnclick(){
    const result: QuizData = Object.assign({}, this.comorbidityquizForm.value);
    let fromResult = Object.assign({}, result);
    
    this.submitted = false;

    console.log("about to check form validation");
    // stop here if form is invalid
    if (this.comorbidityquizForm.invalid) {
      const modalRef = this.modalService.open(NgbdModalContent);
      if (this.getFormValidationErrors()){
        modalRef.componentInstance.name = 'You have left a question unanswered';
      }
      else{
        modalRef.componentInstance.name = 'Please make sure you have formatted all your inputs correctly';
      }
        return;
    }

    const selectedPreexistingConditions = this.comorbidityquizForm.value.preexisting_conditions
        .map((v, i) => v ? this.preexisting_conditions[i].value : null)
        .filter(v => v !== null);
  
    var userInfo = new QuizData()

    userInfo.preexisting_conditions = selectedPreexistingConditions;
    userInfo.health_status = String(this.comorbidityquizForm.get(['health_status']).value);
    
    console.log(userInfo.score)
    this._bkoffService.setComorbidityQuizData(userInfo);

    console.log("btnclick registered")
    this.router.navigateByUrl('/quiz7');   
  };

}


function minSelectedCheckboxes(min:Number) {
  const validator: ValidatorFn = (formArray: FormArray) => {
    const totalSelected = formArray.controls
      .map(control => control.value)
      .reduce((prev, next) => next ? prev + next : prev, 0);

    return totalSelected >= min ? null : { required: true };
  };

  return validator;
}
